import React from 'react';

export const responsive = {
  superLargeDesktop: {
    breakpoint: {max: 4000, min: 3000},
    items: 5,
    partialVisibilityGutter: 40,
  },
  desktop: {
    breakpoint: {max: 3000, min: 1024},
    items: 5,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {max: 1024, min: 464},
    items: 5,
    artialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: {max: 464, min: 0},
    items: 3,
    artialVisibilityGutter: 30,
  },
};

export const landScapeResponsive = {
  superLargeDesktop: {
    breakpoint: {max: 4000, min: 3000},
    items: 9,
    partialVisibilityGutter: 40,
  },
  desktop: {
    breakpoint: {max: 3000, min: 1024},
    items: 9,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {max: 1024, min: 464},
    items: 9,
    artialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: {max: 464, min: 0},
    items: 9,
    artialVisibilityGutter: 30,
  },
};

export const customizeMargin = [
  ['7px'],
  ['7px', '7px'],
  ['11px', '7px', '11px'],
  ['13px', '7px', '7px', '13px'],
  ['18px', '9px', '7px', '9px', '18px'],
  ['25px', '14px', '7px', '7px', '14px', '25px'],
];
